'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var brandOverviewComponent = exports.brandOverviewComponent = {
    template: require('./overview.html'),
    bindings: {
        brands: '<'
    },
    controllerAs: 'vm',
    controller: ["brandService", "lodash", "$location", "gettextCatalog", "common", "Analytics", function controller(brandService, lodash, $location, gettextCatalog, common, Analytics) {
        'ngInject';

        var vm = this;
        vm.brandIndexes = getBrandIndexes(vm.brands);
        vm.currentLanguage = common.localization.getCurrentLanguage();
        vm.scrollTo = scrollTo;

        common.setTitle(gettextCatalog.getString('Brands'));
        Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/brands', gettextCatalog.getString('Brands'));

        function getBrandIndexes(brands) {
            common.navigationMenu.setBrandsActive();
            var indexes = lodash.uniq(lodash.map(brands, function (b) {
                return b.name.charAt(0).toLowerCase();
            })).sort();

            var brandIndexes = lodash.map(indexes, function (i) {
                return {
                    'char': i,
                    'brands': getBrandsByIndex(brands, i)
                };
            });

            return brandIndexes;
        }

        function getBrandsByIndex(brands, char) {
            return lodash.filter(brands, function (b) {
                return b.name.charAt(0).toLowerCase() === char;
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/brand/overview.js
// module id = 898
// module chunks = 0